import $ from "jquery";
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
export default {
  hideAndCloseGallery(el) {
    return $(el).append("<a href=\"#\" class=\"button close-gallery\">Close</a>");
  },

  loadGallery(href) {
    this.injectGallery();
    return $(".gallery-content-inner").on("load", `${href} .expandomatic`, () => {
      $(".gallery-content-inner").append("<a href=\"#\" class=\"button close-gallery\">Close</a>");
      const callback = () => $(".gallery-cover, .gallery-content").removeClass("hidden loading");
      return setTimeout(callback, 10);
    });
  },

  injectGallery() {
    $("body").append("<div class=\"gallery-cover hidden loading\"></div>");
    return $("body").append("<div class=\"gallery-content hidden\"><div class=\"gallery-content-inner\">" +
      "<a href=\"#\" class=\"button close-gallery\">Close</a></div></div>",
    );
  },

  removeGallery() {
    return $(".gallery-cover, .gallery-content").remove();
  },

  enableScrollForBody() {
    return $("body").css("overflow", "auto");
  },

  disableScrollForBody() {
    return $("body").css("overflow", "hidden");
  },
};
